<form *ngIf="step1Form" [formGroup]="step1Form" class="definition-form" id="ce-prj1-form">
  <mat-label class="display-title" id="ce-prj1-cat-label">Select Categories*</mat-label>
  <div class="categories-row" id="ce-prj1-cat-row">
    <div
      class="category-checkbox"
      *ngFor="let cat of categories; let i = index"
      (click)="toggleCategory(i)"
      [class.selected]="step1Form.get('categories')?.get(i.toString())?.value"
      tabindex="0"
      (keydown.space)="toggleCategory(i)"
      role="checkbox"
      [attr.aria-checked]="step1Form.get('categories')?.get(i.toString())?.value"
      [id]="'ce-prj1-cat-' + i"
    >
      <div class="icon-wrapper">
        <div class="category-icon" id="ce-prj1-cat-icn-{{ i }}">
          <app-icon-display [icon]="cat.icon"></app-icon-display>
        </div>
        <span
          class="checkmark"
          *ngIf="step1Form.get('categories')?.get(i.toString())?.value"
          id="ce-prj1-cat-chk-{{ i }}"
        >
          <mat-icon>check_circle</mat-icon>
        </span>
      </div>
      <div
        class="category-label"
        [matTooltip]="cat.categoryTitle.length > 15 ? cat.categoryTitle : ''"
        matTooltipPosition="above"
        [id]="'ce-prj1-cat-lbl-' + i"
      >
        {{ cat.categoryTitle.length > 15 ? (cat.categoryTitle | slice: 0 : 15) + '...' : cat.categoryTitle }}
      </div>
    </div>
  </div>
  <mat-error
    class="error-msg"
    *ngIf="
      step1Form.get('categories')?.invalid &&
      (step1Form.get('categories')?.touched || step1Form.get('categories')?.dirty)
    "
    id="ce-prj1-cat-err"
  >
    Please select at least one category.
  </mat-error>

  <mat-label class="display-title" id="ce-prj1-type-label">Project Type*</mat-label>
  <mat-radio-group formControlName="projectType" required class="project-type" id="ce-prj1-type-group">
    <mat-radio-button
      style="height: 30px !important"
      [disableRipple]="true"
      *ngFor="let type of projectTypes; let j = index"
      [value]="type"
      [id]="'ce-prj1-type-' + j"
    >
      {{ type.projectTypeTitle }}
    </mat-radio-button>
  </mat-radio-group>
  <mat-error
    *ngIf="step1Form.get('projectType')?.hasError('required') && step1Form.get('projectType')?.touched"
    id="ce-prj1-type-err"
  >
    Project type is required.
  </mat-error>

  <div class="products-header">
    <mat-label class="display-title" id="ce-prj1-products-label"> Select Products </mat-label>

    <button mat-raised-button type="button" class="create-test-product-btn" (click)="onCreateTestProductClick()">
      <mat-icon>add</mat-icon>
      Create Test Product
    </button>
  </div>

  <mat-form-field appearance="outline" class="product-search-field" id="ce-prj1-products-search">
    <input
      matInput
      [(ngModel)]="productSearchTerm"
      [ngModelOptions]="{ standalone: true }"
      (input)="onProductSearchChange()"
      placeholder="Enter Key words"
      id="ce-prj1-products-search-input"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <cdk-virtual-scroll-viewport
    *ngIf="visibleProducts.length > 0; else noProducts"
    itemSize="40"
    class="product-results-box"
    id="ce-prj1-products-list"
    (scrolledIndexChange)="onProductsScrolled($event)"
  >
    <div
      class="product-row"
      *cdkVirtualFor="let product of visibleProducts; let k = index"
      [id]="'ce-prj1-product-row-' + k"
      [class.locked-product-row]="isProductLockedByExperiment(product.id)"
      [matTooltip]="getProductLockTooltip(product.id)"
      matTooltipPosition="above"
      (click)="onProductRowClick(product.id)"
      tabindex="0"
      (keydown.space)="$event.preventDefault(); onProductRowClick(product.id)"
    >
      <mat-checkbox
        [checked]="isProductChecked(product.id)"
        [disabled]="isProductLockedByExperiment(product.id) && isProductChecked(product.id)"
        (change)="toggleProduct(product.id, $event.checked)"
        (click)="$event.stopPropagation()"
        [id]="'ce-prj1-product-cb-' + product.id"
      >
      </mat-checkbox>

      <div class="product-pill" [id]="'ce-prj1-product-pill-' + product.id">
        <span
          class="product-text"
          [appEllipsisTooltip]="
            (product.productCode || '') +
            (product.productCode && product.productTitle ? ' | ' : '') +
            (product.productTitle || '')
          "
        >
          <span class="product-code">{{ product.productCode }}</span>
          <span class="dot-sep" *ngIf="product.productCode && product.productTitle">|</span>
          <span class="product-title">{{ product.productTitle }}</span>
        </span>
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
  <div class="no-products" *ngIf="isProductSearchLoading">Loading products...</div>
  <ng-template #noProducts>
    <div class="no-products" id="ce-prj1-products-empty">No products found.</div>
  </ng-template>
</form>
